import { storageKeyForMode } from "./publicGuestMode";

export const MOBILE_EXPERIENCE_KEY = storageKeyForMode("invoice-studio-mobile-experience", "invoice-studio-public-mobile-experience-v1");
export const MOBILE_EXPERIENCES = ["minimal", "advanced"];

export const readMobileExperience = (storage = typeof window === "undefined" ? null : window.localStorage) => {
  if (!storage) return null;
  try {
    const value = storage.getItem(MOBILE_EXPERIENCE_KEY);
    return MOBILE_EXPERIENCES.includes(value) ? value : null;
  } catch {
    return null;
  }
};

export const writeMobileExperience = (value, storage = typeof window === "undefined" ? null : window.localStorage) => {
  if (!storage || !MOBILE_EXPERIENCES.includes(value)) return false;
  try {
    storage.setItem(MOBILE_EXPERIENCE_KEY, value);
    return true;
  } catch {
    return false;
  }
};
